import "./layout.scss";
import Sidebar from "components/CsmComponents/Sidebar/Sidebar";

function Layout({ children, className, mainClass }) {
  return (
    // <div className={className}>
    //   <Header />
    //   <div className="csmLayout__wrapper">
    //     <div className="d-none d-lg-block csmLayout_sidebar_wrapper">
    //       <Sidebar />
    //     </div>
    //     <div className="csmLayout_main_wrapper">
    //       <main className={`csmLayout__main ${mainClass}`}>{children}</main>
    //     </div>
    //   </div>
    //   <Footer />
    <div className="body-bg d-flex">
      <div className="csm-sidebar-container">
        <Sidebar />
      </div>
      <main className={`main-container`}>
        {/* {searchVisible ? (
            <div className="w-100 d-block d-lg-none pt-3">
              <GlobalSearch />
            </div>
          ) : null} */}
        {children}
      </main>
    </div>
    // </div>
  );
}

export default Layout;
